import clsx from 'clsx';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import AddIcon from '../../assets/icons/add.svg?react';
import CloseIcon from '../../assets/icons/close.svg?react';
import { setMenuConfig, useMenuConfig } from '../../services/menu';
import { MenuKeys } from '../../types/menu';
import styles from './CustomiseMenu.module.css';
import { menuOptions } from './menuOptions';

export interface CustomiseItemProps {
  id: MenuKeys;
  type: 'add' | 'remove';
}

const MAXIMUM_MENU_ITEMS = 5;

export const CustomiseItem: FC<CustomiseItemProps> = ({ id, type }) => {
  const config = useMenuConfig();
  const canAddMore = config.length < MAXIMUM_MENU_ITEMS;
  const used = config.includes(id);
  const home = id === 'home';
  const { name, icon } = menuOptions.get(id)!;
  const faded = type === 'add' && (home || used);

  return (
    <div className={clsx(styles.item, faded && styles.faded)}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.name}>
        <FormattedMessage id={name} />
      </div>
      {type === 'add' && canAddMore && !home && !used && (
        <AddIcon
          onClick={() => setMenuConfig([...config, id])}
          className={clsx(styles.icon, styles.btn)}
          data-testid="add-menu"
        />
      )}
      {type === 'remove' && !home && used && (
        <CloseIcon
          onClick={() => setMenuConfig(config.filter((cid) => cid !== id))}
          className={clsx(styles.icon, styles.btn)}
          data-testid="remove-menu"
        />
      )}
    </div>
  );
};
